import React from "react";
import { Route, Routes } from "react-router-dom";
import { CardPaymentApprovalsList } from "./CardPaymentApprovalsList";

const CardPaymentApprovalsModule = () => {
  return (
    <Routes>
      <Route index element={<CardPaymentApprovalsList />} />
    </Routes>
  );
};

export default CardPaymentApprovalsModule;
